import { useMemo } from 'react';
import { useAuthContext } from './context';
import {
	hasModeratorRight,
	isNeighborhoodModerator,
	moderatorHomePath
} from './neighborhood-moderation';
import type { IModeratedNeighborhood, NeighborhoodModeratorRight } from './types';

export interface NeighborhoodModeration {
	/** Utilizatorul e un moderator de cartier (nu staff). */
	isModerator: boolean;
	neighborhood: IModeratedNeighborhood | undefined;
	homePath: string;
	can: (right: NeighborhoodModeratorRight) => boolean;
}

export const useNeighborhoodModeration = (): NeighborhoodModeration => {
	const { user } = useAuthContext();
	return useMemo(
		() => ({
			isModerator: isNeighborhoodModerator(user),
			neighborhood: user?.moderatedNeighborhood,
			homePath: moderatorHomePath(user),
			can: (right: NeighborhoodModeratorRight) => hasModeratorRight(user, right)
		}),
		[user]
	);
};
